<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Messenger" });
import "tailwindcss/tailwind.css";
import { Heading, Paragraph } from "../../typography/index.js";
import { t } from "svelte-i18n";
import { removeMessage, MESSAGES } from "../../stores/messages.js";
</script>

{#if Array.isArray($MESSAGES) && $MESSAGES.length > 0}
    <ul class = 's8-message-list'>
        {#each $MESSAGES as message }
            {#if message.key !== undefined}
                <li
                    class = { `s8-${ message.type }`}
                    on:click = { removeMessage.bind(null, message.key) }
                    on:keypress = { removeMessage.bind(null, message.key) }
                >
                    <Heading size = 'xxs'>{ $t(message.heading) }</Heading>
                    {#if message.description}
                        <Paragraph css = '!mb-0' size = 'sm' label = { message.description } />
                    {/if}
                </li>
            {/if}
        {/each}
    </ul>
{/if}

<style>
    @keyframes slideInFromBottom {
        0% {
            transform: translateY(100%);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: 1;
        }
    }

    ul.s8-message-list {
        position: fixed;
        top: 2rem;
        right: 2rem;
        left: 2rem;
        z-index: 50;
}

    @media (min-width: 640px) {
        ul.s8-message-list {
                left: auto;
        }
}

    ul.s8-message-list li {
        cursor: pointer;
}

    @media (min-width: 640px) {
        ul.s8-message-list li {
                width: 12rem;
        }
}

    ul.s8-message-list li {

            animation: slideInFromBottom 0.5s ease-out;
            border-radius: 5px;
            padding: 15px;
            margin-top: 10px;
        }

    ul.s8-message-list li.s8-success {
                color: #44835F;
                background-color: #D2E1D9;
                box-shadow: 0 2px 2px 0px rgba(39,39,17,0.06), inset 0 -1px 1px 0px rgba(68,131,95,0.12);
            }

    ul.s8-message-list li.s8-warning {
                color: #F49C00;
                background-color: #FBF2CA;
                box-shadow: 0 2px 2px 0px rgba(39,39,17,0.06), inset 0 -1px 1px 0px rgba(239, 201, 35, 0.36);
            }

    ul.s8-message-list li.s8-error {
                color: #EF233B;
                background-color: #F7E4E6;
                box-shadow: 0 2px 2px 0px rgba(39,39,17,0.06), inset 0 -1px 1px 0px rgba(239, 35, 59, 0.36);
            }

    ul.s8-message-list li.s8-info {
                color: #446083;
                background-color: #E8EBF0;
                box-shadow: 0 2px 2px 0px rgba(39,39,17,0.06), inset 0 -1px 1px 0px rgba(68, 96, 131, 0.36);
            }</style>